module.exports = __webpack_public_path__ + "r-v3/img/ico_widget_setting_white.8e0580cb.svg";